import React, { useMemo } from 'react';

import OutsideClickHandler from 'react-outside-click-handler';

import { CheckSIcon, ChevronDownMIcon, ChevronUpMIcon } from 'assets/icons';
import { DropDown } from 'components/uikit/DropDown/DropDown';
import { VOID_FUNCTION } from 'constants/index';

import { TextInput } from '../TextInput/TextInput';

import { DEFAULT_THEME } from './Searcher.constants';
import { useSearcherPresenter } from './Searcher.presenter';
import * as S from './Searcher.styles';

export const Searcher = ({
  dropDownPosition = 'bottom',
  list = [],
  name,
  onChange = VOID_FUNCTION,
  onClick = VOID_FUNCTION,
  onSearch = VOID_FUNCTION,
  size = 'm',
  theme = DEFAULT_THEME,
  value,
  ...rest
}) => {
  const presenter = useSearcherPresenter({ list, name, onChange, onClick, onSearch, value });

  const options = useMemo(() => {
    return list.map((item) => {
      const { description, id, subTitle, title } = item ?? {};

      const selected = value === id;

      return (
        <S.ListItemStyled
          description={description}
          gap={8}
          key={`searcher-option-${id}`}
          leftSlot={selected ? <S.CheckIcon Icon={CheckSIcon} /> : <S.EmptyIcon />}
          onClick={() => presenter.onOptionClick(item)}
          selected={selected}
          size={size}
          subTitle={subTitle}
          title={title}
        />
      );
    });
  }, [list, value, presenter.onOptionClick, size]);

  return (
    <>
      <OutsideClickHandler onOutsideClick={presenter.onOutsideClick}>
        <TextInput
          {...rest}
          Icon={presenter.visible ? ChevronUpMIcon : ChevronDownMIcon}
          iconPosition="right"
          size={size}
          theme={theme}
          value={presenter.value}
          wrapperRef={presenter.inputRef}
          onChange={presenter.onSearch}
          onClick={presenter.onClick}
          onFocus={presenter.onFocus}
          onBlur={presenter.onBlur}
        />
      </OutsideClickHandler>
      {presenter.visible && (
        <DropDown
          gap={10}
          position={dropDownPosition}
          ref={presenter.dropDownRef}
          targetRef={presenter.inputRef}
        >
          <S.DropDownContainer size={size} theme={theme}>
            {options}
          </S.DropDownContainer>
        </DropDown>
      )}
    </>
  );
};
